/**
 * Theme color constants for ECharts styling
 * Centralizes color usage across all chart style utilities
 * Using Mantine default color palette
 */
export const GRAY_0 = 'var(--mantine-color-ldGray-0)';
export const GRAY_1 = 'var(--mantine-color-ldGray-1)';
export const GRAY_2 = 'var(--mantine-color-ldGray-2)';
export const GRAY_3 = 'var(--mantine-color-ldGray-3)';
export const GRAY_4 = 'var(--mantine-color-ldGray-4)';
export const GRAY_5 = 'var(--mantine-color-ldGray-5)';
export const GRAY_6 = 'var(--mantine-color-ldGray-6)';
export const GRAY_7 = 'var(--mantine-color-ldGray-7)';
export const GRAY_8 = 'var(--mantine-color-ldGray-8)';
export const GRAY_9 = 'var(--mantine-color-ldGray-9)';
// White
export const WHITE = 'var(--mantine-color-white)';
export const FOREGROUND = 'var(--mantine-color-foreground-0)';
export const BACKGROUND = 'var(--mantine-color-background-0)';
export const TOOLTIP_BACKGROUND = 'var(--mantine-color-background-1)';
export const AXIS_TITLE_COLOR = 'var(--mantine-color-gray-6)';
//# sourceMappingURL=themeColors.js.map